import * as THREE from "three";
import { PointerLockControls } from "three/addons/controls/PointerLockControls.js";

export class Player {
	camera = new THREE.PerspectiveCamera(
		70,
		window.innerWidth / window.innerHeight,
		0.1,
		200
	);
	controls = new PointerLockControls(this.camera, document.body);
	cameraHelper = new THREE.CameraHelper(this.camera);

	height = 1.75;
	radius = 0.5;
	maxSpeed = 5;
	jumpSpeed = 10;
	onGround = false;

	velocity = new THREE.Vector3();
	#worldVelocity = new THREE.Vector3();
	input = new THREE.Vector3();
	/**
	 * @param {THREE.Scene} scene
	 */
	constructor(scene) {
		this.position.set(32, 16, 32);
		this.cameraHelper.visible = false;
		scene.add(this.camera);
		scene.add(this.cameraHelper);

		// Wireframe mesh visualizing the player's bounding cylinder
		this.boundsHelper = new THREE.Mesh(
			new THREE.CylinderGeometry(this.radius, this.radius, this.height, 16),
			new THREE.MeshBasicMaterial({ wireframe: true })
		);
		scene.add(this.boundsHelper);

		// Add event listeners for keyboard/mouse events
		document.addEventListener("keydown", this.onKeyDown.bind(this));
		document.addEventListener("keyup", this.onKeyUp.bind(this));
	}

	/**
	 * Updates the state of the player based on the current user inputs
	 * @param {Number} dt
	 */
	applyInputs(dt) {
		if (this.controls.isLocked) {
			this.velocity.x = this.input.x;
			this.velocity.z = this.input.z;
			this.controls.moveRight(this.velocity.x * dt);
			this.controls.moveForward(this.velocity.z * dt);
			this.position.y += this.velocity.y * dt;
		}
		document.getElementById("info-player-position").innerHTML = this.toString();
	}
	/**
	 * Updates the position of the player's bounding cylinder helper
	 */
	updateBoundsHelper() {
		this.boundsHelper.position.copy(this.camera.position);
		this.boundsHelper.position.y -= this.height / 2;
	}
	/**JAH FIRST
	 * * Returns the current world position of the player
	 * @returns {THREE.Vector3}
	 */
	get position() {
		return this.camera.position;
	}

	/**
	 * Returns the velocity of the player in world coordinates
	 * @returns {THREE.Vector3}
	 */
	get worldVelocity() {
		this.#worldVelocity.copy(this.velocity);
		this.#worldVelocity.applyEuler(
			new THREE.Euler(0, this.camera.rotation.y, 0)
		);
		return this.#worldVelocity;
	}

	/**
	 * Applies a change in velocity 'dv' that is specified in the world frame
	 * @param {THREE.Vector3} dv
	 */
	applyWorldDeltaVelocity(dv) {
		dv.applyEuler(new THREE.Euler(0, -this.camera.rotation.y, 0));
		this.velocity.add(dv);
	}

	/**JAH FIRST
	 * Event handler for 'keyup' event
	 * @param {KeyboardEvent} event
	 */
	onKeyUp(event) {
		switch (event.code) {
			case "KeyW":
				this.input.z = 0;
				break;
			case "KeyA":
				this.input.x = 0;
				break;
			case "KeyS":
				this.input.z = 0;
				break;
			case "KeyD":
				this.input.x = 0;
				break;
			case "KeyR":
				this.position.set(32, 16, 32);
				this.velocity.set(0, 0, 0);
				break;
		}
	}

	/**JAH FIRST
	 * Event handler for 'keydown' event
	 * @param {KeyboardEvent} event
	 */
	onKeyDown(event) {
		if (!this.controls.isLocked) {
			this.controls.lock();
			console.log("controlsLocked");
		}

		switch (event.code) {
			case "KeyW":
				this.input.z = this.maxSpeed;
				break;
			case "KeyA":
				this.input.x = -this.maxSpeed;
				break;
			case "KeyS":
				this.input.z = -this.maxSpeed;
				break;
			case "KeyD":
				this.input.x = this.maxSpeed;
				break;
			case "KeyR":
				if (this.repeat) break;
				this.position.set(32, 10, 32);
				this.velocity.set(0, 0, 0);
				break;
			case "Space":
				if (this.onGround) {
					this.velocity.y += this.jumpSpeed;
				}
				break;
		}
	}

	/**JAH FIRST
	 * Returns player position in a readable string form
	 * @returns {string}
	 */
	toString() {
		let str = "";
		str += `X : ${this.position.x.toFixed(3)}`;
		str += `Y : ${this.position.y.toFixed(3)}`;
		str += `Z : ${this.position.z.toFixed(3)}`;
		return str;
	}
}
